import { useEffect, useMemo, useState } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import _ from "lodash";

export default function AutoCompleteTextField({
  name,
  value,
  label,
  onChange,

  freeSolo,

  values,
  itemGetLabel,
  itemGetValue,

  isRequired,
  disabled,
}) {
  if (isRequired === null) {
    isRequired = true;
  }

  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    if (isRequired) {
      if (values?.length === 1) {
        const _value = itemGetValue ? itemGetValue(values[0]) : itemGetLabel(values[0]);
        onChange?.({ target: { name: name } }, _value);
      }
    }
  }, [values]);

  const handleOnBlur = (event) => {
    setIsEdited(true);

    const newEvent = event;
    newEvent.target.name = name;

    if (itemGetValue) {
      const _nativeValue = event?.target?.value;
      const _foundItem = values?.find((v) => itemGetLabel(v) === _nativeValue);
      if (_foundItem) {
        onChange?.(newEvent, itemGetValue(_foundItem));
      } else {
        onChange?.(newEvent, null);
      }
    } else {
      onChange?.(newEvent, event?.target?.value);
    }
  };

  const getIsError = useMemo(() => (isRequired ? !value : false), [isRequired, value]);

  const getErrorText = useMemo(() => (getIsError && isEdited ? "Required" : " "), [getIsError, isEdited]);

  const calculateUniqueValues = () => {
    if (values) {
      return _.uniqBy(values, (v) => itemGetLabel(v))?.sort((a, b) => itemGetLabel(a)?.localeCompare(itemGetLabel(b)));
    } else {
      return null;
    }
  };

  return (
    <>
      <FormControl sx={{ m: 0, p: 0, width: "100%" }}>
        <Autocomplete
          disablePortal
          disabled={disabled}
          freeSolo={freeSolo}
          sx={{ width: "100%" }}
          name={name}
          value={value || null}
          options={
            calculateUniqueValues() &&
            calculateUniqueValues()?.map((currentItem) => {
              // Bind primitives:
              return itemGetLabel(currentItem);
            })
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={label || ""}
              InputProps={{
                ...params.InputProps,
                id: null,
                autoComplete: "new-password",
                form: {
                  autoComplete: "off",
                },
                m: 0,
                p: 0,
                // inputComponent: getInputComponentType(maskType)
              }}
              sx={{ m: 0, p: 0 }}
              error={getIsError}
              helperText={getErrorText}
            />
          )}
          onChange={(event, value) => {
            ////console.log(value);
            const newEvent = event;
            newEvent.target.name = name;
            ////console.log(newEvent);
            onChange?.(newEvent, value);
          }}
          autoSelect
          autoHighlight
          onBlur={handleOnBlur}
          onFocus={(e) => e.target.select()}
        />
      </FormControl>
    </>
  );
}
